(() => {
  const SELECTOR = '[data-embe-skin-slidehow]';

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.dataset.embeInit === '1') return;
      el.dataset.embeInit = '1';

      if (!window.Swiper) return;

      const autoplayEnabled = el.dataset.autoplay === 'true';
      const autoplayDelay = Number(el.dataset.autoplayDelay || 5000);
      const loop = el.dataset.loop !== 'false';
      const prev = el.querySelector('.swiper-button-prev');
      const next = el.querySelector('.swiper-button-next');

      const opts = {
        slidesPerView: 1,
        effect: 'fade',
        loop,
        speed: 600,
        roundLengths: true,
        fadeEffect: {
          crossFade: true
        }
      };

      if (autoplayEnabled) {
        opts.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false
        };
      }

      if (prev && next) {
        opts.navigation = { prevEl: prev, nextEl: next };
      }

      // eslint-disable-next-line no-new
      new window.Swiper(el, opts);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
  });
})();

